import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid") setStatus("paid");
        else if (tries < 12) {
          setTries((n) => n + 1);
          setTimeout(check, 2000);
        } else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    check();
    return () => { cancelled = true; };
  }, [sid, tries]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center space-y-6 fade-up">
        <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-600" />
        <h1 className="font-display text-4xl font-black tracking-tighter">
          {status === "paid" ? "Pagamento riuscito!" : status === "checking" ? "Verifica pagamento…" : "In elaborazione"}
        </h1>
        <p className="text-muted-foreground">
          {status === "paid" ? "Il tuo abbonamento è attivo. Grazie!" : "Stiamo confermando il pagamento con Stripe."}
        </p>
        <Link to="/dashboard/subscription">
          <Button className="pill-btn bg-primary text-primary-foreground hover:bg-[hsl(var(--accent))]" data-testid="ps-go-dashboard-btn">
            Vai al pannello
          </Button>
        </Link>
      </div>
    </div>
  );
}
